function buildResourceIframe(url) {
  return `<iframe src="${url}" width="100%" height="800" frameborder="0"></iframe>`
}

export default buildResourceIframe
